import type {
  GetAdminV1StoresStoreIdReportsProductsEngagementSort,
  ReportInterval,
} from '@nucleus-commerce/api-client/admin';

import type { DayRange } from '../schemas/report-range';

/** Store-scoped keys: a rollup invalidates everything under `all`. */
export const reportKeys = {
  all: (storeId: string) => ['stores', storeId, 'reports'] as const,
  overview: (storeId: string, range: DayRange) =>
    [...reportKeys.all(storeId), 'overview', range] as const,
  sales: (storeId: string, range: DayRange, interval: ReportInterval) =>
    [...reportKeys.all(storeId), 'sales', range, interval] as const,
  products: (storeId: string, range: DayRange, limit: number) =>
    [...reportKeys.all(storeId), 'products', range, limit] as const,
  productEngagement: (
    storeId: string,
    range: DayRange,
    sort: GetAdminV1StoresStoreIdReportsProductsEngagementSort,
  ) => [...reportKeys.all(storeId), 'product-engagement', range, sort] as const,
  customers: (storeId: string, range: DayRange, limit: number) =>
    [...reportKeys.all(storeId), 'customers', range, limit] as const,
  payments: (storeId: string, range: DayRange) =>
    [...reportKeys.all(storeId), 'payments', range] as const,
  support: (storeId: string, range: DayRange) =>
    [...reportKeys.all(storeId), 'support', range] as const,
  inventory: (storeId: string) => [...reportKeys.all(storeId), 'inventory'] as const,
  auctions: (storeId: string, range: DayRange) =>
    [...reportKeys.all(storeId), 'auctions', range] as const,
};
